import { isNil } from 'lodash';
import { decrypt as decryptOpenPGP, readMessage } from 'openpgp';

import { parseKeyPair } from '../parse-key-pair/parse-key-pair';

import { DecryptInput, DecryptOutput } from './interfaces';

export const decrypt = async (params: DecryptInput): Promise<DecryptOutput> => {
  const { publicKey, privateKey } = await parseKeyPair(params.keyPair);

  const message = await readMessage({
    ...(getBinaryOrArmoredMessage(params.message) as any),
  });
  // decryption will fail if all signatures are invalid or missing
  const { data: decrypted } = await decryptOpenPGP({
    message,
    decryptionKeys: privateKey,
    // mandatory if expectSigned=true
    verificationKeys: publicKey,
  });

  return { decrypted };
};

const getBinaryOrArmoredMessage = (
  value: string | Uint8Array,
): { armoredMessage: string } | { binaryMessage: Uint8Array } => {
  if (isNil(value)) {
    console.error('getBinaryOrArmoredMessage: Cannot parse because required value is nil', { value });
    throw new Error('getBinaryOrArmoredMessage: Cannot parse because required value is nil');
  }
  if (value instanceof Uint8Array) {
    return { binaryMessage: value };
  }
  if (typeof value === 'string') {
    return { armoredMessage: value };
  }
  console.error('getBinaryOrArmoredMessage: Unknown value', { value });
  throw new Error('getBinaryOrArmoredMessage: Unknown type');
};
